module.exports = __RENDER_8_COMPONENTS__['vtex.css-handles@0.x/useCssHandles'];